import React, { useEffect, useState } from 'react';

const Question3 = ({ response, setSubmitDisabled, question, handleResponse }) => {

  const [selectedResponse, setSelectedResponse] = useState(response);

  const handleChange = (event) => {
    const value = event.target.value === 'true';
    setSelectedResponse(value);
    handleResponse(2, value);
  };

  const renderMessageBox = () => {
    if (selectedResponse === true) {
      return (
        <div className="message-box">
          <div>
            <i className="fas fa-info-circle blue"></i>
          </div>
          <div className='message-content'>
            <p>Study Design Identified: <strong>{question.name}</strong></p>
            <br />
            <p>Requirements:</p>
            <div className='requirement-item'>
              <div><i className="fas fa-check blue"></i></div>
              <p dangerouslySetInnerHTML={{__html: question.message_html}}></p>
            </div>
            <div className='requirement-item'>
              <div><i className="fas fa-check blue"></i></div>
              <div className='clinical-trial-container'>
                <p><strong>Clinical trial registration </strong> required before publication.</p>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  const renderRctRadioButtons = () => {
    return (
      <div className='question-block'>
        <h5>{question.question_text}</h5>
        <div>
          <ul>
            <li>Random assignment of participants</li>
            <li>A control or comparator group</li>
            <li>Prospective assignment of a treatment or intervention</li>
          </ul>
        </div>
        <input
          type="radio"
          name="rct"
          value="false"
          onChange={handleChange}
          checked={selectedResponse === false}
          id="rct_false"
        />
        <label htmlFor="rct_false">{question.false_response_text}</label>
        <br />
        <input
          type="radio"
          name="rct"
          value="true"
          onChange={handleChange}
          checked={selectedResponse === true}
          id="rct_true"
        />
        <label htmlFor="rct_true">{question.true_response_text}</label>
        <br />
        {renderMessageBox()}
      </div>
    );
  };

  return (
    <div>
      {renderRctRadioButtons()}
    </div>
  );
};

export default Question3;